import { Search, Clock, Sparkles } from 'lucide-react';

/**
 * Suggestions/popular/recent searches dropdown for SmartSearch.
 * Extracted from SmartSearch.jsx to reduce component size.
 */
export default function SearchSuggestionsDropdown({
  suggestions,
  searchQuery,
  popularSearches,
  recentSearches,
  applySearch,
}) {
  return (
    <div 
      className="absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl shadow-2xl border z-50 overflow-hidden"
      data-testid="smart-search-dropdown"
    >
      {/* Smart Suggestions */}
      {suggestions.length > 0 && (
        <div className="p-4 border-b">
          <h4 className="text-xs font-semibold text-slate-400 uppercase mb-2 flex items-center gap-1">
            <Sparkles className="h-3 w-3" /> Smart Suggestions
          </h4>
          <div className="space-y-1">
            {suggestions.map((suggestion, idx) => (
              <button
                key={`suggestion-${suggestion.label || idx}`}
                onClick={() => applySearch(suggestion)}
                className={`w-full flex items-center gap-3 p-3 rounded-lg text-left transition-colors ${
                  suggestion.highlight 
                    ? 'bg-coral/10 hover:bg-coral/20 text-coral' 
                    : 'hover:bg-slate-50'
                }`}
              >
                <suggestion.icon className="h-5 w-5" />
                <span className="font-medium">{suggestion.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Popular Searches */}
      {!searchQuery && (
        <div className="p-4 border-b">
          <h4 className="text-xs font-semibold text-slate-400 uppercase mb-2">Popular Searches</h4>
          <div className="flex flex-wrap gap-2">
            {popularSearches.map((search) => (
              <button
                key={`popular-${search.label}`}
                onClick={() => applySearch(search)}
                className="flex items-center gap-2 px-3 py-2 bg-slate-50 hover:bg-slate-100 rounded-full text-sm transition-colors"
              >
                <search.icon className="h-4 w-4 text-slate-500" />
                {search.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Recent Searches */}
      {recentSearches.length > 0 && !searchQuery && (
        <div className="p-4">
          <h4 className="text-xs font-semibold text-slate-400 uppercase mb-2">Recent Searches</h4>
          <div className="space-y-1">
            {recentSearches.map((search) => (
              <button
                key={`recent-${search.label}`}
                onClick={() => applySearch(search)}
                className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 text-left"
              >
                <Clock className="h-4 w-4 text-slate-400" />
                <span>{search.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* No Results */}
      {searchQuery && suggestions.length === 0 && (
        <div className="p-8 text-center text-slate-500">
          <Search className="h-8 w-8 mx-auto mb-2 text-slate-300" />
          <p>Press Enter to search for &ldquo;{searchQuery}&rdquo;</p>
        </div>
      )}
    </div>
  );
}
